import { 
    Button, 
    Dialog, 
    DialogTitle, 
    Box,
    DialogContent,
    DialogActions
} from '@mui/material';
import React from 'react';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import LoadAgentMap from './AiAgents/LoadAgentMap';
import { useNavigate } from 'react-router-dom';

function LoadAgentDialogBox({open, onClose}) {
    const navigate = useNavigate()
  return (
    <Dialog 
        open={open} 
        onClose={onClose}
        PaperProps={{
            sx:{
                width:'65%',
                margin:'auto',
                borderRadius:'15px'
            }
        }}
        >
            <Box
            sx={{
                display:'flex',
                justifyContent:'flex-end',
                mt:'15px'
            }}
            >
            <Button
                onClick={onClose}
                color='black'
            >
                <CancelOutlinedIcon fontSize='small'/>
            </Button>
            </Box>
        <DialogTitle fontWeight={'bold'}>
            LOAD MY AGENT
        </DialogTitle>
        <DialogContent >
            <LoadAgentMap />
        </DialogContent>
        <DialogActions
            sx={{
                display:'flex',
                alignItems:'center',
                justifyContent:'center'
            }}
        >
  
        </DialogActions>
    </Dialog>
  )
}

export default LoadAgentDialogBox
